import React, { useEffect, useContext, useState } from "react";
import DataTable from "core/ui/data-table";
import FormatCurrency from "core/utils/FormatCurrency";
import { Link, useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import SessionContext from "SessionContext";
import ProgressLoader from "../partials/progress-loader";
import { animatedStyle } from "../core/ui/forms/file-uploader";

export const nameStyle = {
  color: '#4a65a5',
  fontWeight: '300'
}

const CompanyLicense = (props) => {
  const session = useContext(SessionContext);
  const history = useHistory();

  const [companyInfo, setCompanyInfo] = useState();
  const [editUrl, setEditUrl] = useState({id: "", name: ""});
  const [isLoadingLicenses, setIsLoadingLicenses] = useState(true);

  const table_columns = [
    {
      header: "Start Date",
      key: "start_date",
      render: (value) => value.start_date,
      // render: (value) => dayjs(value.start_date).format("YYYY-MM-DD"),
    },
    {
      header: "End Date",
      key: "end_date",
      render: (value) => value.end_date,
    },
    {
      header: "Fee",
      key: "fee",
      render: (value) => <FormatCurrency value={value.fee} />,
    },
    { header: "Frequency", key: "monthly_frequency" },
    { header: "License Status", 
      key: "is_enabled",
      render: (value) => {return value.is_enabled ? "Active" : "Inactive"}
    }
  ];

  const table_actions = (license) => {
    const edit_url = "/admin-company-edit-license";
    return (
      <ul className="action-menu">
        <Link 
          to={{
            pathname: edit_url,
            search: `?license_id=${license.id}&company_id=${editUrl.id}&name=${editUrl.name}`
          }}
        >
          <i className="bi bi-pencil" /> Edit
        </Link>
      </ul>
    );
  }

  useEffect(() => {
    session.query("companies/get", { id: props.args.company_id })
           .then((response) => {
              setCompanyInfo(response);
              setCompanyDetailsArgs(response);
            })
    // eslint-disable-next-line
  }, [props.args.company_id])

  const setCompanyDetailsArgs = (info) => {
    setEditUrl({id: info.id, name: info.name});
    setIsLoadingLicenses(false);
  };

  const backToCompanyDetails = () => {
    if(editUrl.id) {
      history.push(`/admin-company-form#company_id=${editUrl.id}`);
    } else {
      history.push("/admin-companies");
    }
  }

  /* wait until done loading data before rendering */
  if(isLoadingLicenses) {
    return (
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <Button className="new-button" onClick={backToCompanyDetails} disabled={!editUrl.id}>
            <i className="bi bi-chevron-left"></i> Company Details
          </Button>
          <h1>Company Licenses</h1>
          <i className="spacer" />
        </div>
        <div className="loading-text">Loading</div>
        <section className="loading-wrapper">
          <span style={animatedStyle}>
            <ProgressLoader />
          </span>
        </section>
      </div>
    )
  }

  return (
    <div className="page orders-page">
      <div className="list-header sticky-page-header">
        <Button className="new-button" onClick={backToCompanyDetails} disabled={!editUrl.id}>
          <i className="bi bi-chevron-left"></i> Company Details
        </Button>
        <h1>Company Licenses</h1>
        <i className="spacer" />
        <Link to={`/admin-company-edit-license?company_id=${editUrl.id}&name=${editUrl.name}`}>
          <Button className="new-button">
            New License
          </Button>
        </Link>
      </div>

      <div className="mt-4 mb-4">
        <h4>
          Company:{" "}
          {companyInfo && <span style={nameStyle}>{companyInfo.name}</span>}
        </h4>
      </div>

      <DataTable
        query={`admin/license_fee_list`}
        cols={table_columns}
        params={{
          am_company_id: props.args.company_id,
          sort_by: 'start_date',
          sort_asc: true
        }}
        actions={table_actions}
        empty="No Licenses Found"
      />
    </div>
  );
};

export default CompanyLicense;

